'use client';
import { FC } from 'react';

import { useTrackPricingCardClick } from '@/hooks/useTrackPricingCardClick';

import PricingSectionCardCell from '@/blocks/PricingSection/Desktop/Components/PricingSectionCardCell';
import Button from '@/components/atoms/Button';
import { transformLinkToButtonProps } from '@/components/atoms/LinkButton/utils';

import { createHrefWithExperimentTracking } from '@/blocks/PricingCards/utils';
import { usePathname } from 'next/navigation';
import { PricingSectionCardType, PricingSectionCtaButton } from '../../types';
import {
  getPricingCardTrackEventName,
  getPricingCardTrackExtra,
  getPricingCardTrackId,
} from '../../utils';

type Props = {
  type: PricingSectionCardType;
  ctaButton: PricingSectionCtaButton;
  cardHeader: string;
  badgeOfHonor: string | null;
};

const PricingSectionCardCTA: FC<Props> = ({
  type,
  ctaButton,
  badgeOfHonor,
  cardHeader,
}) => {
  const pathname = usePathname();
  const trackEventName = getPricingCardTrackEventName(type);
  const trackId = getPricingCardTrackId(ctaButton);
  const trackExtra = getPricingCardTrackExtra(cardHeader, ctaButton);

  const handleClick = useTrackPricingCardClick({
    trackEventName,
    trackId,
    trackExtra,
  });

  const { href, target, element } = transformLinkToButtonProps({
    ...ctaButton,
    url: createHrefWithExperimentTracking(ctaButton.url, pathname),
  });

  return (
    <PricingSectionCardCell
      hasBadgeOfHonor={!!badgeOfHonor}
      classNames={{ wrapper: 'py-3 px-3' }}
    >
      <Button
        isDecoro={true}
        as={element}
        href={href}
        target={target}
        variant={ctaButton.variant}
        color={ctaButton.color}
        leftSection={ctaButton.leftSection}
        rightSection={ctaButton.rightSection}
        data-tracker-context={trackId}
        classNames={{ root: 'w-full' }}
        onClick={() => handleClick()}
      >
        {ctaButton.text}
      </Button>
    </PricingSectionCardCell>
  );
};

export default PricingSectionCardCTA;
